module.exports = __webpack_public_path__ + "img/coupon.74981e81.png";